<template>
  <div>
    <slot />
    <img
      data-cy="pref-ring-central"
      src="/images/ringcentral.svg"
      class="h-3 cursor-pointer"
      :class="{
        'opacity-70 grayscale':
          preferredDialer !== CommunicationProvider.RingCentral,
      }"
      loading="lazy"
      @click="setPreferredDialer(CommunicationProvider.RingCentral)"
    />
    <img
      v-if="allowTwilioUse"
      data-cy="pref-twilio"
      src="/images/twilio.svg"
      class="mt-0-5 h-3 cursor-pointer"
      :class="{
        'opacity-70 grayscale':
          preferredDialer !== CommunicationProvider.Twilio,
      }"
      loading="lazy"
      @click="setPreferredDialer(CommunicationProvider.Twilio)"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";

import { storeToRefs } from "pinia";

import { CommunicationProvider } from "@/enums/communicationProviders";
import { PhoneNumberPreferences } from "@/enums/preferences";
import { useAuth } from "@/hooks/auth";
import { useTwilio } from "@/hooks/communicationProviders";
import { usePreferencesMutation } from "@/hooks/queries/profile/usePreferences";
import { useTwilioStore } from "@/stores/twilio";

import type { UpdatePhoneNumberRoutingPayload } from "@/models/preferences";

const auth = useAuth();
const { dispatch } = useStore();
const twilioStore = useTwilioStore();
const { userAssignedPhoneNumbers } = storeToRefs(twilioStore);

const { preferredDialer } = useTwilio();
const { mutateAsync } = usePreferencesMutation();

const allowTwilioUse = computed(
  () => !!userAssignedPhoneNumbers.value?.length && auth.isLendflowUser
);

const setPreferredDialer = async (type: CommunicationProvider) => {
  const preferences: UpdatePhoneNumberRoutingPayload = {
    key: PhoneNumberPreferences.provider,
    value: type,
  };
  await mutateAsync([preferences]);
  await dispatch("auth/getAuthDetails");
};
</script>
